import { render, staticRenderFns } from "./ProvisaoFooter.vue?vue&type=template&id=434f0828&scoped=true"
import script from "./ProvisaoFooter.vue?vue&type=script&lang=ts"
export * from "./ProvisaoFooter.vue?vue&type=script&lang=ts"
import style0 from "./ProvisaoFooter.vue?vue&type=style&index=0&id=434f0828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f0828",
  null
  
)

export default component.exports